import React, { Component } from "react";
import axios from "axios";
import { getUser } from "../../../actions/session";
import { Notifications } from "../../common/notification";
import { ACCOUNT_TAB_STIR_SHAKEN } from "../../../config/rest_endpoints";

class GlobalAddSubjectBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      User: getUser(),
      subject: "",
      note: "",
      isLoad: false,
      msg: "",
      userId: this.props.accountID,
    };

    this.onHandleChange = this.onHandleChange.bind(this);
    this.onSubmitChange = this.onSubmitChange.bind(this);
  }

  onHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  clearForm() {
    this.setState({ subject: "", note: "" });
  }

  onSubmitChange() {
    const { subject, note, User, userId } = this.state;
    if (!subject) {
      Notifications.notify("All form fields are required", "Error", "error");
      return;
    }

    const payload = {
      stirShakenSubject: subject,
      note,
    };

    this.setState({ isLoad: true });

    const headers = { Authorization: `Bearer ${User.token}` };

    axios
      .post(`${ACCOUNT_TAB_STIR_SHAKEN}`, payload, { headers })
      .then((res) => {
        this.setState({ msg: res.data.message, isLoad: false });
        this.props.close();
        this.props.listingServer();
        this.clearForm();
        Notifications.notify(res.data.message, "Created", "success");
      })
      .catch((err) => {
        let message = "Something went wrong";
        if (err.response && err.response.data && err.response.data.message) {
          message = err.response.data.message;
        } else if (err.message) {
          message = err.message; // Fallback for network errors
        }
        this.setState({ isLoad: false });
        Notifications.notify(message, "Failed", "error");
      });
  }

  render() {
    const { subject, note, isLoad } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label style={{ fontWeight: "400", fontSize: "16px" }}>
                Stir Shaken Subject
              </label>
              <input
                type="text"
                className="form-control"
                name="subject"
                value={subject}
                onChange={this.onHandleChange}
                placeholder="Enter subject"
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <label style={{ fontWeight: "400", fontSize: "16px" }}>
                Note
              </label>
              <textarea
                className="form-control"
                name="note"
                value={note}
                onChange={this.onHandleChange}
                placeholder="Enter note"
                rows="4"
              />
            </div>
          </div>
        </div>
        <div className="row" style={{ borderTop: "1px solid #e9ecef" }}>
          <div className="col-md-6 ml-auto">
            <button
              type="submit"
              className="mt-2 main-button btn btn-sm btn-success float-right"
              disabled={isLoad}
              onClick={this.onSubmitChange}
            >
              Add{" "}
              {isLoad ? (
                <i className="fas fa-spinner fa-spin ml-1"></i>
              ) : (
                <i className="icon-file-plus ml-1 icon-1x"></i>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default GlobalAddSubjectBlock;
